<template>
  <div class="expertises-page">
    <!-- Intro -->
    <div class="intro-section" ref="expertise">
      <div class="content-wrapper">
        <h1 class="page-title">{{ $t('expertiseSection.title') }}</h1>
        <p
          class="intro-text"
          v-html="$t('expertisesPage.introSection.paragraph2')"
        ></p>
      </div>
    </div>

    <!-- Accordion List -->
    <div class="practices-list">
      <div
        v-for="practice in translatedLegalPractices"
        :key="practice.ref"
        class="practice-item"
        :ref="practice.ref"
      >
        <!-- Header -->
        <div
          class="item-header"
          @click="toggleSection(practice.ref)"
          :class="{ open: isSectionOpen(practice.ref) }"
        >
          <h2 class="item-title">{{ practice.title }}</h2>
          <span
            :class="['dropdown-icon', { rotated: isSectionOpen(practice.ref) }]"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
              class="icon-svg"
            >
              <path
                d="M12 15.172l-4.95-4.95a1 1 0 011.414-1.414L12 12.343l3.536-3.535a1 1 0 011.414 1.414l-4.95 4.95z"
              ></path>
            </svg>
          </span>
        </div>

        <!-- Expandable Content -->
        <transition
          name="expand"
          @enter="onEnter"
          @after-enter="onAfterEnter"
          @leave="onLeave"
        >
          <div class="item-content" v-show="isSectionOpen(practice.ref)">
            <p
              v-for="(paragraph, pIndex) in practice.content"
              :key="pIndex"
              class="content-paragraph"
              v-html="paragraph"
            ></p>

            <ul v-if="practice.list" class="content-list">
              <li
                v-for="(listItem, liIndex) in practice.list"
                :key="liIndex"
                v-html="listItem"
              ></li>
            </ul>

            <p
              v-if="practice.footerContent"
              class="content-paragraph footer"
              v-html="practice.footerContent"
            ></p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpertiseComponent",
  data() {
    return {
      openSectionRef: null,
      rawLegalPractices: [
        {
          ref: "litigationArbitration",
          titleKey:
            "expertisesPage.legalPracticesDetails.litigationArbitration.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.litigationArbitration.content1",
            "expertisesPage.legalPracticesDetails.litigationArbitration.content2",
          ],
          listKeys: [
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item1",
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item2",
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item3",
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item4",
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item5",
            "expertisesPage.legalPracticesDetails.litigationArbitration.list.item6",           
          ],
          footerKey:
            "expertisesPage.legalPracticesDetails.litigationArbitration.footer",
        },
        {
          ref: "bankingFinance",
          titleKey:
            "expertisesPage.legalPracticesDetails.bankingFinance.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.bankingFinance.content1",
            "expertisesPage.legalPracticesDetails.bankingFinance.content2",
            "expertisesPage.legalPracticesDetails.bankingFinance.content3",
            "expertisesPage.legalPracticesDetails.bankingFinance.content4",
            "expertisesPage.legalPracticesDetails.bankingFinance.content5",
          ],
        },
        {
          ref: "mergersAcquisitions",
          titleKey:
            "expertisesPage.legalPracticesDetails.mergersAcquisitions.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.mergersAcquisitions.content1",
            "expertisesPage.legalPracticesDetails.mergersAcquisitions.content2",
            "expertisesPage.legalPracticesDetails.mergersAcquisitions.content3",
          ],
        },
        {
          ref: "employmentLaw",
          titleKey:
            "expertisesPage.legalPracticesDetails.employmentLaw.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.employmentLaw.content1",
            "expertisesPage.legalPracticesDetails.employmentLaw.content2",
          ],
          listKeys: [
            "expertisesPage.legalPracticesDetails.employmentLaw.list.item1",
            "expertisesPage.legalPracticesDetails.employmentLaw.list.item2",
            "expertisesPage.legalPracticesDetails.employmentLaw.list.item3",
            "expertisesPage.legalPracticesDetails.employmentLaw.list.item4",
            "expertisesPage.legalPracticesDetails.employmentLaw.list.item5",
          ],
          footerKey:
            "expertisesPage.legalPracticesDetails.employmentLaw.footer",
        },
        {
          ref: "realEstate",
          titleKey: "expertisesPage.legalPracticesDetails.realEstate.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.realEstate.content1",
            "expertisesPage.legalPracticesDetails.realEstate.content2",
            "expertisesPage.legalPracticesDetails.realEstate.content3",
          ],
        },
        {
          ref: "competitionLaw",
          titleKey:
            "expertisesPage.legalPracticesDetails.competitionLaw.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.competitionLaw.content1",
            "expertisesPage.legalPracticesDetails.competitionLaw.content2",
            "expertisesPage.legalPracticesDetails.competitionLaw.content3",
          ],
        },
        {
          ref: "commercialCorporate",
          titleKey:
            "expertisesPage.legalPracticesDetails.commercialCorporate.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.commercialCorporate.content1",
            "expertisesPage.legalPracticesDetails.commercialCorporate.content2",
          ],
        },
        {
          ref: "telecomITMedia",
          titleKey:
            "expertisesPage.legalPracticesDetails.telecomITMedia.title",
          contentKeys: [
            "expertisesPage.legalPracticesDetails.telecomITMedia.content1",
            "expertisesPage.legalPracticesDetails.telecomITMedia.content2",
            "expertisesPage.legalPracticesDetails.telecomITMedia.content3",
          ],
        },
        
      ],
    };
  },
  computed: {
    translatedLegalPractices() {
      return this.rawLegalPractices.map((practice) => {
        const translatedPractice = { ...practice };
        if (practice.titleKey) {
          translatedPractice.title = this.$t(practice.titleKey);
        }
        if (practice.contentKeys) {
          translatedPractice.content = practice.contentKeys.map((key) => {
            const translatedText = this.$t(key);
            return translatedText.replace(/\*\*(.*?)\*\*/g, "$1");
          });
        }
        if (practice.listKeys) {
          translatedPractice.list = practice.listKeys.map((key) => {
            const translatedText = this.$t(key);
            const parts = translatedText.split(" – ");
            if (parts.length > 1) {
              return `${parts[0]} – ${parts.slice(1).join(" – ")}`;
            }
            return translatedText;
          });
        }
        if (practice.footerKey) {
          translatedPractice.footerContent = this.$t(practice.footerKey);
        }
        return translatedPractice;
      });
    },
  },
  methods: {
    toggleSection(refName) {
      this.openSectionRef = this.openSectionRef === refName ? null : refName;
    },
    isSectionOpen(refName) {
      return this.openSectionRef === refName;
    },
    onEnter(el) {
      el.style.height = "auto";
      const height = getComputedStyle(el).height;
      el.style.height = "0";
      getComputedStyle(el).height;
      requestAnimationFrame(() => {
        el.style.height = height;
      });
    },
    onAfterEnter(el) {
      el.style.height = "auto";
    },
    onLeave(el) {
      el.style.height = getComputedStyle(el).height;
      getComputedStyle(el).height;
      requestAnimationFrame(() => {
        el.style.height = "0";
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");

/* --- General Layout --- */
.expertises-page {
  min-height: 100vh;
  background-color: #f9fafb;
  font-family: "Poppins", sans-serif;
  color: #2c2c2c;
}

/* --- Intro --- */
.intro-section {
  background: #bbd55a;
  padding: 100px 20px;
    text-align: justify;
  text-justify: inter-word;
  color: #0d1a26;
}

.page-title {
  font-size: 3rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  text-align: center;
}

.intro-text {
  font-size: 1.15rem;
  line-height: 1.8;
  max-width: 700px;
  margin: 20px auto 0;
}

/* --- Accordion Container --- */
.practices-list {
  max-width: 900px;
  margin: -40px auto 0px;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* --- Accordion Item --- */
.practice-item {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}
.practice-item:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

/* --- Header --- */
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 24px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.item-header.open {
  background-color: #f5f7f0;
}

.item-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  color: #2c2c2c;
}

.dropdown-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease, color 0.3s ease;
  color: #9bb73f;
}
.dropdown-icon.rotated {
  transform: rotate(180deg);
  color: #7fa22e;
}
.icon-svg {
  width: 100%;
  height: 100%;
}

/* --- Content --- */
.item-content {
  padding: 0 24px 24px;
  line-height: 1.7;
    text-align: justify;
  text-justify: inter-word;
}

.content-paragraph {
  font-size: 1rem;
  margin-bottom: 1rem;
}

.content-paragraph.footer {
  font-style: italic;
  color: #555;
}

.content-list {
  list-style: none;
  padding-left: 0;
  margin: 1rem 0;
}

.content-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 0.6rem;
}
.content-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #bbd55a;
  font-size: 1.2em;
}

/* --- Transitions --- */
.expand-enter-active,
.expand-leave-active {
  transition: height 0.35s ease;
  overflow: hidden;
}
.expand-enter-from,
.expand-leave-to {
  height: 0;
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .page-title {
    font-size: 2.4rem;
  }
  .intro-text {
    font-size: 1rem;
  }
  .item-title {
    font-size: 1.15rem;
  }
}
@media (max-width: 480px) {
  .page-title {
    font-size: 2rem;
  }
  .intro-section {
    padding: 70px 20px;
  }
}
</style>
